var render = function render(){var _vm=this,_c=_vm._self._c;return _c('tippy',{attrs:{"to":_vm.to,"theme":"light","trigger":"click","arrow":"true","arrow-type":"round","boundary":"viewport","animate-fill":"false","animation":"shift-away","allow-h-t-m-l":"true"}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }